import moment from 'moment';

export const formatDate = (stringDate) => {
  return moment(stringDate).format('ddd MM/DD');
};
